import apiFetch from '../apiFetch'

export default function (idAnalisis, token) {
  return apiFetch({endPoint: `Foso/getExtraccion?idAnalisis=` + idAnalisis, method: 'GET', body: null, token: token})
}